import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    itemContainer: {
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        aspectRatio: 1,
        width: "100%"
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: "100%"
    },
    headerTitleContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    gridContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    itemTitle: {
        textAlign: "center",
        width: "100%"
    },
    emptyText: {
        textAlign: "center"
    },
    modalBottomContainer: {
        width: "100%"
    },
    contentContainer: {
        maxHeight: 700,
        width: "100%",
        height: 600,
        flex: 1
    },
    itemWrapper: {
        width: "23%"
    }
});

export default stylesheet;
